import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessionStorageUtils } from '../utils/session-storage';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  
  constructor(private http: HttpClient,
              private activatedRouter: ActivatedRoute) { }

  private sessionStorage = new SessionStorageUtils();
  private publicKey = `5h9Bb71nB0v1Rj4gvhd1CLzDaPdU0LQUjQ9uElcU26amZSo3wZ3Zloce93RUWkqhelBUgVSyzImAaVXF8l3YcmLsJReDBxwvQcBD`;

  public URL_API = environment.URL_API;
  public URL_CDN = environment.URL_CDN;
  public IS_IFRAME = false;

  public HEADER = { headers: new HttpHeaders({
    // 'Authorization': `Bearer ${this.sessionStorage.onGetToken()}`,
    'Chave-Publica': `${this.publicKey}`
  })};

  public getContent<T>(url: string, params?: string): Observable<T>{
    return this.http.get<T>(`${this.URL_API}/${url}${params || ''}`, this.HEADER);
  }

  public postContent<T>(url: string, body: any, params?: string): Observable<T>{
    return this.http.post<T>(`${this.URL_API}/${url}${params || ''}`, body, this.HEADER);
  }

  public putContent<T>(url: string, body: any, params?: string): Observable<T>{
    return this.http.put<T>(`${this.URL_API}/${url}${params || ''}`, body, this.HEADER);
  }

  public getHeaderReferer(url: any){
    let HEADER_REFERER = { headers: new HttpHeaders({
      'Chave-Publica': `${this.publicKey}`,
      'Referer-Test': url
    })};
    return HEADER_REFERER;
  }

  public getHeaderNoReferer(url: any, refPath: any){
    let HEADER_REFERER = { headers: new HttpHeaders({
      'Chave-Publica': `${this.publicKey}`,
      'Referer-Test': url,
      'Referer-Folder': refPath
    })};
    return HEADER_REFERER;
  }

  onCheckIframe(): boolean{
    this.activatedRouter.queryParams.subscribe((param: any) => {      
      if(param.template === 'iframe') this.IS_IFRAME = true;
    })
    return this.IS_IFRAME;
  }
}
